<header class="header" id="header">
  <nav aria-labelledby="header">
    <h2>Simulador de formalización</h2>
    <img src="/assets/images/dian-lodo.png" alt="icon">
</nav>
</header>
